import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { removeStorageItem } from "../../helpers/index";

class SuperAdminLogoutConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  onClickLogOut = () => {
    let accessToken = removeStorageItem("accessToken");
    removeStorageItem("feathers-jwt");
    removeStorageItem("userData");

    if (!accessToken) {
      this.props.history.push("/signin");
    }
  };

  render() {
    const { showModal, onCloseModal } = this.props;

    return (
      <div id="logoutConfirmationModal" className={showModal ? "show" : "hide"}>
        <div className="modal-backdrop"></div>
        <div className="modal-container sm">
          <div className="modal-header">
            <h4>LOGOUT CONFIRMATION</h4>
          </div>
          <div className="modal-body">
            <p>Are you sure want to logout?</p>
          </div>
          <div className="modal-footer">
            <button
              className="button warning btn-cancel"
              onClick={() => onCloseModal()}
              style={{ marginRight: "25px" }}
            >
              Cancel
            </button>
            <button
              className="button primary btn"
              onClick={() => this.onClickLogOut()}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuperAdminLogoutConfirmationModal);
